/**
 * @param {string|Array.<string|number>} keys Either a key (sorted ascending)
 *  or a key and number indicating direction ['key', 0] (> 0 is ascending, < 0 is descending)
 * @returns {function(*, *): *} The method to provide to the .sort() to perform the sort.
 * @example sortBy(['key', 1])(arr)
 */
export const sortBy = (...keys) => (a, b) =>
  keys.map(input => {
    let key;
    let dir = 1; // ascending

    if (typeof input === 'string') {
      key = input;
    } else if (Array.isArray(input)) {
      [key, dir] = input;
    } else {
      throw new Error(`Invalid key ${key}`);
    }

    return (a[key]?.toLowerCase?.() ?? a[key]) < (b[key]?.toLowerCase?.() ?? b[key])
      ? -dir
      : (b[key]?.toLowerCase?.() ?? b[key]) < (a[key]?.toLowerCase?.() ?? a[key])
        ? dir
        : 0
  }).find(r => r) || 0;